export const AZURE_AUTH_CHANGED_EVENT = "skillfits:azure-auth-changed"

type AuthChangedDetail = {
  waitUntil?: (operation: Promise<void>) => void
}

export async function notifyAzureAuthChanged(): Promise<void> {
  if (typeof window === "undefined") return

  const pending: Promise<void>[] = []
  window.dispatchEvent(
    new CustomEvent<AuthChangedDetail>(AZURE_AUTH_CHANGED_EVENT, {
      detail: {
        waitUntil(operation) {
          pending.push(operation)
        },
      },
    }),
  )
  await Promise.allSettled(pending)
}
